import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import es from './es.json';
import en from './en.json';

const SOPORTADOS = ['es', 'en'];

function idiomaNavegador() {
  const nav = (navigator.language || navigator.userLanguage || '').toLowerCase();
  return nav.startsWith('en') ? 'en' : 'es';
}

// Orden de resolución INICIAL: preferencia explícita del usuario → 'es' por defecto (producto español-first).
// (El idioma del TENANT se aplica al cargar el tenant, ver store, y va por delante.)
function idiomaInicial() {
  const explicito = localStorage.getItem('hueco-idioma');
  if (explicito && SOPORTADOS.includes(explicito)) return explicito;
  return 'es';
}

const esDesarrollo = process.env.NODE_ENV === 'development';

i18n.use(initReactI18next).init({
  resources: { es: { translation: es }, en: { translation: en } },
  lng: idiomaInicial(),
  fallbackLng: 'es',
  interpolation: { escapeValue: false },
  // En desarrollo avisa por consola de cualquier clave que falte, para que NUNCA se muestre
  // en pantalla texto crudo tipo "movimiento.anterior".
  saveMissing: esDesarrollo,
  missingKeyHandler: esDesarrollo
    ? (lngs, ns, key) => console.warn(`[i18n] Falta traducción: "${key}" (${lngs.join(', ')})`)
    : undefined,
});

// El usuario elige idioma explícitamente (máxima prioridad, persiste).
export function cambiarIdioma(lng) {
  localStorage.setItem('hueco-idioma', lng);
  i18n.changeLanguage(lng);
}

// Aplica el idioma del TENANT SOLO si el usuario no ha elegido uno explícitamente. No persiste.
export function aplicarIdiomaTenant(idioma) {
  if (localStorage.getItem('hueco-idioma')) return; // manda la preferencia del usuario
  const lng = SOPORTADOS.includes(idioma) ? idioma : idiomaNavegador();
  if (i18n.language !== lng) i18n.changeLanguage(lng);
}

export default i18n;
